import React from 'react';
import { Button } from 'antd';

export const BotonPrincipal = ({ text, colorFondo, colorTexto, onClick }) => {
  return (
    <Button
      className="BotonPrincipal"
      style={{
        backgroundColor: colorFondo,
        color: colorTexto,
        fontSize: "1.5em",
        border: "none",
        borderRadius: "1em",
        height: "2.5em", 
        lineHeight: "2.5em", 
        padding: "0 1em", 
        transition: "transform 0.2s ease", 
        transform: "none",
        display: "inline-flex", 
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};
